import type { BitmapData } from "../../runtime";
import {
  BG_fortress1,
  BG_fortress2,
  BG_fortress3,
  zone1Block1,
  zone1Block2,
  zone1Obs,
  zone2Block1,
  zone2Block2,
  zone2Obs,
  zone3Block1,
  zone3Block2,
  zone3Obs,
  zoneCityDaybgBottom,
  zoneCityDaybgMiddle,
  zoneCityDaybgTop,
  zoneCitybgBottom,
  zoneCitybgMiddle,
  zoneCitybgTop,
  zoneDaybgBottom,
  zoneDaybgMiddle,
  zoneDaybgTop,
  zoneFortressbgMiddle,
  zoneNightbgBottom,
  zoneNightbgMiddle,
  zoneNightbgTop,
  zoneSunsetbgBottom,
  zoneSunsetbgMiddle,
  zoneSunsetbgTop,
  zoneUndergroundbgBottom,
  zoneUndergroundbgMiddle,
  zoneUndergroundbgTop,
  zoneVRbg,
} from "../assets";

/** One of the generated asset bitmaps in `assets.ts`. */
export type SheetCtor = new (w?: number, h?: number) => BitmapData;

/** Parallax sky layers of a zone, plus which sheet set its tiles come from. */
export interface ZoneBackground {
  readonly top: SheetCtor;
  readonly middle: SheetCtor;
  readonly bottom: SheetCtor;
  /** index into `ZONE_SHEETS` */
  readonly type: number;
}

/** Obstacle and block tile sheets, indexed by a zone's `type`. */
export interface ZoneSheets {
  readonly obs: SheetCtor;
  readonly blockA: SheetCtor;
  readonly blockB: SheetCtor;
}

/** Fortress backdrop drawn behind the level, by fortress stage. */
export interface FortressSprite {
  readonly spr: SheetCtor;
  readonly width: number;
  readonly height: number;
  /** parallax factor, also scales the level-space offsets */
  readonly mult: number;
}

/** Sky stack shape for a level of a given height in tiles. */
export interface BgVerticalLayout {
  readonly middleRows: number;
  readonly offsetY: number;
}

/** Sky layers per level zone id. Zones 7-9 are unused by any level. */
export const ZONE_BACKGROUNDS: Readonly<Record<number, ZoneBackground>> = {
  0: {
    top: zoneDaybgTop,
    middle: zoneDaybgMiddle,
    bottom: zoneDaybgBottom,
    type: 0,
  },
  1: {
    top: zoneSunsetbgTop,
    middle: zoneSunsetbgMiddle,
    bottom: zoneSunsetbgBottom,
    type: 2,
  },
  2: {
    top: zoneNightbgTop,
    middle: zoneNightbgMiddle,
    bottom: zoneNightbgBottom,
    type: 1,
  },
  3: {
    top: zoneCityDaybgTop,
    middle: zoneCityDaybgMiddle,
    bottom: zoneCityDaybgBottom,
    type: 0,
  },
  4: {
    top: zoneUndergroundbgTop,
    middle: zoneUndergroundbgMiddle,
    bottom: zoneUndergroundbgBottom,
    type: 2,
  },
  5: {
    top: zoneCitybgTop,
    middle: zoneCitybgMiddle,
    bottom: zoneCitybgBottom,
    type: 1,
  },
  // the fortress zone reuses its middle band for all three layers
  6: {
    top: zoneFortressbgMiddle,
    middle: zoneFortressbgMiddle,
    bottom: zoneFortressbgMiddle,
    type: 2,
  },
  10: { top: zoneVRbg, middle: zoneVRbg, bottom: zoneVRbg, type: 1 },
};

export const ZONE_SHEETS: readonly ZoneSheets[] = [
  { obs: zone1Obs, blockA: zone1Block1, blockB: zone1Block2 },
  { obs: zone2Obs, blockA: zone2Block1, blockB: zone2Block2 },
  { obs: zone3Obs, blockA: zone3Block1, blockB: zone3Block2 },
];

export const FORTRESS_SPRITES: Readonly<Record<number, FortressSprite>> = {
  1: { spr: BG_fortress1, width: 481, height: 344, mult: 0.39 },
  2: { spr: BG_fortress2, width: 598, height: 427, mult: 0.42 },
  3: { spr: BG_fortress3, width: 820, height: 587, mult: 0.44 },
};

/** Sky stack layout per level height in tiles. Heights 1 and 6 are unused. */
export const BG_VERTICAL_LAYOUT: Readonly<Record<number, BgVerticalLayout>> = {
  2: { middleRows: 0, offsetY: -260 },
  3: { middleRows: 0, offsetY: -90 },
  4: { middleRows: 0, offsetY: 0 },
  5: { middleRows: 1, offsetY: -335 },
  7: { middleRows: 2, offsetY: -460 },
  8: { middleRows: 2, offsetY: -300 },
  9: { middleRows: 2, offsetY: -100 },
};
